import { Card, FC, useMemo } from 'external/react'
import { clsx } from 'external/clsx'

import useParent from 'context/parent-context/hook'

import BadgeCounter from 'components/BadgeCounter'

import HomeItem from 'components/HomeItem'

const HomePage = () => {
    const {homeData, navigation} = useParent()
    const home = homeData as any
    const [showPackagesBadges, showUsersBadges] = useMemo(() =>
        [!!(Number(home.num_packages_not_assigned) || Number(home.num_packages_assigned)), !!(Number(home.student_count) || Number(home.tutor_count))],
    [home]) 
	return (
            <Card.Body className='mt-2'>
               <div className="row mt-3 mb-3">
                    <HomeItem icon='faBox' label='Paquetes' to={'/home/packages'}>
                        {showPackagesBadges && (<div className='text-muted mb-2'>
                            <BadgeCounter count={Number(home.num_packages_not_assigned)} label='paquete' />
                            <BadgeCounter count={Number(home.num_packages_assigned)} label='paquete asignado' plural='paquetes asignados'/>
                        </div>)}
                        <BottomPadding visible={!showPackagesBadges} />
                        </HomeItem>
                    <HomeItem icon='faUsers' label='Usuarios' to={navigation.users.link({role: 'student'})}>
                        {showUsersBadges && (<div className='text-muted mb-2'>
                            <BadgeCounter count={Number(home.student_count)} label='estudiante' />
                            <BadgeCounter count={Number(home.tutor_count)} label='tutor' plural='tutores'/>
                        </div>)}
                        <BottomPadding visible={!showUsersBadges} />
                    </HomeItem>
                    <HomeItem icon='faHandHoldingDollar' label='Pagos' to='/home/payment'>
                        <BottomPadding />
                    </HomeItem>
                    <HomeItem icon='faHeadset' label='Apoyo' to='/home/support'>
                        <BottomPadding />
                    </HomeItem>
                </div>
            </Card.Body>
	)
}

const BottomPadding: FC<{visible?: boolean, className?: string}> = props => {
    const {visible = true, className = 'text-muted mb-2'} = props
    return (<div className={clsx(className, {'d-none': !visible})}><span className='text-white'>.</span></div>)
}

export default HomePage;